export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8246.8458ed68.jpg";